// extracted by mini-css-extract-plugin
export default {"capitalize":"WYmjX"};